import React, { useState } from "react";
import { RatingBadge } from "Components/Rating";
import { SpinningButton } from "Components/ReactstrapSlim";
import { ITeamMemberReservation } from "Services/API/API";
import { formatReservationTime } from "Utils/datetime";
import ReviewModal from "./ReviewModal";
import moment from "moment";

export interface AttendanceProps {
   reservation: ITeamMemberReservation;
   changeReservationState: (wasVisited: boolean) => void;
   onLeaveReview: (reservation: ITeamMemberReservation) => void;
}

export const Attendance: React.FC<AttendanceProps> = ({ reservation, changeReservationState, onLeaveReview = () => { /* empty */ } }) => {
   const [isVisitLoading, setVisitLoading] = useState<boolean>(false);
   const [isNotVisitLoading, setIsNotVisitLoading] = useState<boolean>(false);

   const [reservationForReview, setReservationForReview] = useState<ITeamMemberReservation>();

   const visitReservation = async () => {
      setVisitLoading(true);
      await changeReservationState(true);
      setVisitLoading(false);
      setReservationForReview(reservation);
   }

   const skipReservation = async () => {
      setIsNotVisitLoading(true);
      await changeReservationState(false);
      setIsNotVisitLoading(false);
   }

   const onCloseInternal = () => {
      setReservationForReview(undefined);
   }

   return (
      <div className="attendance-wrapper">
         <div className="venue-info col-12 col-lg-8">
            <div className="venue-img col-12 col-sm-4" style={{ backgroundImage: `url(${reservation.picture})` }}>
               <div className="venue-badges">
                  <div className="venue-badges-right">
                     <RatingBadge averageRating={reservation.venueAverageRating} ratingCount={reservation.venueRatingCount} />
                  </div>
               </div>
            </div>
            <div className="venue-overview col-12 col-sm-8">
               <div className="reservation-date"><span>{moment(reservation.startTime).format("MMM D,")}</span>{` ${moment(reservation.startTime).format("dddd")} ${formatReservationTime(reservation.startTime, reservation.endTime)}`}</div>
               <div className="details">
                  <div className="venue-name">{reservation.venueName}</div>
               </div>
               <div className="venue-address">{reservation.address}</div>
            </div>
         </div>
         <div className="attendance-form col-12 col-lg-4">
            <div className="question-wrapper">
               <div className="question">Did you attend this reservation?</div>
               <div className="btn-wrapper">
                  <SpinningButton size="sm" color="secondary" onClick={async () => await skipReservation()} disabled={isVisitLoading || isNotVisitLoading} isLoading={isNotVisitLoading}>No</SpinningButton>
                  <SpinningButton size="sm" color="primary" onClick={async () => await visitReservation()} disabled={isVisitLoading || isNotVisitLoading} isLoading={isVisitLoading}>Yes</SpinningButton>
               </div>
            </div>
         </div>
         {reservationForReview
            ? <ReviewModal isOpen={true} reservation={reservationForReview} onClosePopup={() => onCloseInternal()} onLeaveReview={() => onLeaveReview(reservationForReview)} />
            : null}
      </div>);
}